/**
 * Slovak counts three ways: one, two-to-four, and five-or-more.
 *
 * English gets away with `${count} children` because it only has two forms. Slovak does not, and
 * "1 detí" reads as broken to every person who will use this back office.
 */
export const plural = (count: number, one: string, few: string, many: string): string => {
  if (count === 1) return `${count} ${one}`;
  if (count >= 2 && count <= 4) return `${count} ${few}`;

  return `${count} ${many}`;
};

export const children = (count: number): string => plural(count, 'dieťa', 'deti', 'detí');

export const days = (count: number): string => plural(count, 'deň', 'dni', 'dní');

export const errorTypes = (count: number): string =>
  plural(count, 'typ chýb sa', 'typy chýb sa', 'typov chýb sa');

export const levels = (count: number): string => plural(count, 'úroveň', 'úrovne', 'úrovní');
